import { Reducer } from 'redux';
import { UserActionTypes, UserState } from './types';
import { SharedActionTypes } from '../shared/types';

const initialState: UserState = {
  suggestions: [],
  errors: undefined,
  loading: false,
  users: []
};

const reducer: Reducer<UserState> = (state = initialState, action) => {
  switch (action.type) {
    case UserActionTypes.FETCH_REQUEST:
    case UserActionTypes.FETCH_REQUEST_AUTOCOMPLETE: {
      return { ...state, loading: true };
    }
    case UserActionTypes.UPDATE_USER_SUCCESSFULL:
    case UserActionTypes.FETCH_SUCCESS: {
      const users = action.payload;

      return {
        ...state,
        loading: false,
        users: [...state.users, users]
      };
    }
    case UserActionTypes.FETCH_SUCCESS_AUTOCOMPLETE: {
      const users = action.payload;

      return {
        ...state,
        loading: false,
        suggestions: users
      };
    }
    case UserActionTypes.FETCH_ERROR:
    case UserActionTypes.FETCH_ERROR_AUTOCOMPLETE: {
      return { ...state, loading: false, errors: action.payload };
    }
    case UserActionTypes.CLEAR_SUGGESTIONS: {
      return { ...state, suggestions: [] };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

// Insead of using default export, we use named exports. That way we can group these exports
// inside the `index.ts` folder.
export { reducer as userReducer };



// WEBPACK FOOTER //
// ./src/store/user/reducer.ts